import { useMemo } from 'react';
import { useGameStore } from '../../simulation/store';
import { coordToWorld, rectCoords } from '../../utils/grid';
import { zoneColour } from '../materials';

export function SelectionOverlay() {
  const drag = useGameStore((state) => state.drag);
  const size = useGameStore((state) => state.world.size);
  const coords = useMemo(() => (drag ? rectCoords(drag.start, drag.current) : []), [drag]);

  if (!drag) {
    return null;
  }

  return (
    <group>
      {coords.map((coord) => {
        const position = coordToWorld(coord, size);
        return (
          <mesh key={`selection-${coord.x}-${coord.z}`} position={[position.x, 0.08, position.z]} rotation={[-Math.PI / 2, 0, 0]}>
            <planeGeometry args={[0.92, 0.92]} />
            <meshBasicMaterial color={zoneColour(drag.zone)} transparent opacity={0.58} />
          </mesh>
        );
      })}
    </group>
  );
}
